/**
 * Là tài sản điều chuyển
 */
export default {
  All: -1,
  NotTransfer: 0,
  IsTransfer: 1,
};
